// userAPI

import axios from "axios";
import API_BASE_URL from "../BaseURL/baseURL";
import axiosInstance from "../BaseURL/axiosInstance";

export function fetchLoggedInUserInfo(Email) {
  return new Promise(async (resolve, reject) => {
    try {
      // const response = await axios.get(
      //   `${API_BASE_URL}/User/GetUserData_New?Email=${encodeURIComponent(
      //     Email
      //   )}`
      // );
      const response = await axiosInstance.get(
        `/User/GetUserData_New?Email=${encodeURIComponent(Email)}`
      );
      if (response.status === 200) {
        // Adjust the condition based on your actual response structure
        resolve(response.data);
      } else {
        reject({ message: "Failed to fetch user detail" });
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export function fetchPDEInfo(PDE_ID) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/PDE?PreReg_ID=${encodeURIComponent(PDE_ID)}`
      );
      if (response.status === 200) {
        resolve(response.data);
      } else {
        reject({ message: "Failed to fetch PDE detail" });
      }
    } catch (error) {
      reject(error);
    }
  });
}
